import Reflux from "reflux";
import config from "../config/app";

import SiteService from "../service/SiteService.mjs";

const SiteActions = Reflux.createActions({
  loadPage: { asyncResult: true, children: ["complete", "fail"] },
  loadSite: { asyncResult: true, children: ["complete", "fail"] },
  setDesign: {},
  addFolder: {},
  addPage: {},
  addGlobalCode: {},
  updateGlobalCode: {},
  removeGlobalCode: {},
  createCanvasSet: {},
  addCodePageException: {},
  addBlock: {},
  addBlockCompleted: {},
  addBlockState: {},
  addCanvasToCanvasSet: {},
  addDesignItem: {},
  addElement: {},
  addElementFromUploadingAsset: {},
  addSiteBlock: {},
  addSiteBlockCompleted: {},
  afterLoadSiteVersionCheck: {},
  copy: {},
  copyBlockIntoBlock: {},
  convertToSiteBlock: {},
  convertToPageBlock: {},
  domainConnect: {},
  domainConnectBlog: {},
  duplicateBlock: {},
  duplicateCanvasSet: {},
  duplicateBlockState: {},
  duplicateElement: {},
  duplicateElementGroup: {},
  duplicatePage: {},
  makeCanvasSetDefault: {},
  moveLayer: {},
  moveItem: {},
  sortBlockByReadingOrder: {},
  sortPageByReadingOrder: {},
  pageLoaded: {},
  paste: {},
  pasteInto: {},
  previewDesign: {},
  previewComplete: {},
  designLocked: {},
  removeSelectedElements: {},
  removeBlock: {},
  removeBlockState: {},
  removeCanvasFromCanvasSet: {},
  removeCanvasSet: {},
  removeElement: {},
  removeElementGroup: {},
  removePage: {},
  removeFolder: {},
  removeSiteBlock: {},
  replaceSiteBlock: {},
  toggleItemsLockStatus: {},
  toggleElementGroupLock: {},
  replaceSiteBlockCompleted: {},
  replaceBlock: {},
  replaceBlockCompleted: {},
  resizeToAspectRatio: {},
  siteListsUpdated: {},
  saveJSON: {},
  setAsHomePage: {},
  specialPaste: {},
  togglePageIsPublishable: {},
  updateBlock: {},
  updateBlockName: {},
  updateBlockStateName: {},
  updateCanvasSet: {},
  updateDesign: {},
  recordRecentPexelsPhoto: {},
  updateElementName: {},
  updateItemName: {},
  updatePage: {},
  updatePageName: {},
  updatePageWpTemplate: {},
  updateRendererVersion: {},
  updateTheme: {},
  undo: {},
  redo: {},
});

SiteActions.loadSite.listen(function (data) {
  SiteService.loadSite(data).then(this.complete).catch(this.fail);
});

SiteActions.loadPage.listen(function (data) {
  SiteService.loadPage(data).then(this.complete).catch(this.fail);
});

export default SiteActions;
